var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.widget_sidebar.display_categories)?_c('div',[_c('h6',{staticClass:"title"},[_vm._v(" Categories ")]),_c('ul',{staticClass:"list-unstyled mb-0 p-0"},_vm._l(([{
        id: '',
        name: 'All Categories'
      }, ..._vm.categories]),function(category){return _c('li',{key:category.id,staticClass:"category cursor-pinter",class:{'color-primary ': _vm.categoryModel === category.id},on:{"click":function($event){_vm.categoryModel = category.id}}},[_vm._v(" "+_vm._s(category.name)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }